export default {
  TITLE: 'Quer descobrir o valor do imóvel que seus clientes podem comprar?',
  INFO_TEXT: 'Calcule o potencial de compra de acordo com a renda familiar para auxiliar na busca por imóveis',
  LABEL_BUTTON: 'Saiba mais',
};
